module.exports = __webpack_public_path__ + "static/teleco_6-488847ed2509c00d4f499e4e1cfddece.jpg";